
export const DICE_COLOR = '#AF2828';
